import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

import ve from "./ve";
import pe from "./pe";

const messages = {
  ve,
  pe,
};

const i18n = new VueI18n({
  locale: "ve", // set locale
  messages, // set locale messages
});

// Hot updates
if (module.hot) {
  module.hot.accept(["./ve", "./pe"], function() {
    i18n.setLocaleMessage("ve", require("./ve").default);

    // Or the following hot updates via $i18n property
    // app.$i18n.setLocaleMessage('en', require('./en').default)
    // app.$i18n.setLocaleMessage('ja', require('./ja').default)
  });
}

export default i18n;
